import { Button, createStyleSheet, Divider, IconButton, Text, useStyleSheet, useThemeContext, View, useTextInputContext } from '@gopeerproject/ui-kit';
import React, { useRef } from 'react';
import { useOutsideAlerter } from '../../../hooks';
export const LinkTooltip = ({ left, top, title, value }) => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const { editor, toggleTool } = useTextInputContext();
    const ref = useRef(null);
    const remove = () => {
        const quill = editor;
        const range = quill.getSelection();
        if (!range)
            return;
        const [leaf, offset] = quill.getLeaf(range.index);
        quill.formatText(range.index - offset, leaf.domNode.length, 'link', false);
    };
    useOutsideAlerter(ref, () => {
        toggleTool('link-tooltip');
    });
    return (React.createElement(View, { style: [styles.container, { top: top - size.B, left }], ref: ref },
        React.createElement(IconButton, { value: 'dismiss', type: 'tertiary', accent: 'neutral', onPress: () => {
                toggleTool('link-tooltip');
            }, style: styles.dismiss, size: 'sm' }),
        React.createElement(View, { style: styles.main },
            React.createElement(Text, { type: 'body', size: 'lg', style: styles.title, weight: 'regular', numberOfLines: 1 }, title),
            React.createElement("a", { href: value, target: '_blank', rel: 'noreferrer' },
                React.createElement(Text, { type: 'body', size: 'lg', style: styles.value, weight: 'regular', numberOfLines: 1 }, value))),
        React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
        React.createElement(View, { style: styles.footer },
            React.createElement(Button, { leftIcon: 'edit', size: 'md', accent: 'neutral', text: 'Edit', type: 'tertiary', onPress: () => {
                    toggleTool('link-input');
                } }),
            React.createElement(Button, { leftIcon: 'delete', size: 'md', accent: 'negative', text: 'Remove', type: 'tertiary', onPress: remove }))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        position: 'absolute',
        // @ts-expect-error: supported by web but not by react native
        transform: [{ translateY: '-100%' }],
        backgroundColor: color.bg.v3,
        boxShadow: '0 8px 42px rgba(28, 29, 40, 0.1)',
        borderRadius: size.G,
        width: 360,
        cursor: 'default'
    },
    dismiss: { position: 'absolute', top: size.G, right: size.G, zIndex: 1 },
    main: { padding: size.K, gap: size.C },
    title: { paddingRight: size.L },
    value: {
        color: color.primary.solid,
        textDecorationLine: 'underline'
    },
    divider: { marginHorizontal: size.K },
    footer: {
        padding: size.G,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        gap: size.C
    }
}));
//# sourceMappingURL=LinkTooltip.js.map